import React, { useState, useEffect } from 'react';
import {
  Button,
  TextField,
  Container,
  Grid,
  Typography,
  Paper,
  Tabs,
  Tab,
  Box,
  List,
  ListItem,
  Card,
  CardContent,
  CardMedia,
  makeStyles,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Checkbox
} from '@material-ui/core';
import SendIcon from '@mui/icons-material/Send';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import Breadcrumb from '../BreadcrumbsComponent';
import { SearchFilters } from './SearchFilters';
import { GoogleMap, LoadScript, Marker, InfoWindow } from '@react-google-maps/api';
import logo from '../../assets/images/logos/smart_search.png';
import { Menu, MenuItem, ListItemIcon, ListItemText } from '@material-ui/core';
import SmartCmaIcon from '../../assets/images/logos/smart_cma_small.png'; // Import your Smart CMA icon
import SmartReportsIcon from '../../assets/images/logos/smart_reports_small.png';
import ComingSoon from "../ComingSoon"; // Import your Smart Reports icon


const useStyles = makeStyles((theme) => ({
  userMessage: {
    padding: '8px 16px',
    backgroundColor: '#3f51b5',
    color: '#fff',
    borderRadius: '15px',
    maxWidth: '70%',
  },
  computerMessage: {
    padding: '8px 16px',
    backgroundColor: 'rgba(244, 244, 244)',
    color: '#000',
    borderRadius: '15px',
    maxWidth: '70%',
  },
  card: {
    width: 345,
    margin: '0 8px 16px 8px', // Added bottom margin
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    transition: 'transform 0.5s ease, opacity 0.5s ease',
  },
  media: {
    height: 140, // Ensure the image height is visible
  },
  faded: {
    opacity: 0.5,
    transform: 'scale(0.9)',
  },
  active: {
    opacity: 1,
    transform: 'scale(1)',
  },
  cardContent: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  logoContainer: {
    flexGrow: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  chatWindow: {
    padding: '0 16px 16px 16px', // No top padding, 16px for right, bottom, and left
    marginBottom: '8px', // Reduce margin-bottom
  },
  chatList: {
    flexGrow: 1,
    overflowY: 'auto',
    padding: '16px',
    borderBottom: '1px solid #ccc',
    width: 'calc(100% + 32px)', // Increase width slightly
    marginLeft: '-16px' // Adjust to center the List
  },
}));



const containerStyle = {
  width: '100%',
  height: '100%',
};

const center = {
  lat: 43.809738805593845,
  lng: -79.38801970554911,
};

const mockProperties = [
  {
    address: '3 Wildrose Crescent',
    numBeds: 4,
    numBaths: 4,
    sqft: "2500-3000",
    imageUrl: 'src/assets/images/smart-search/3_wildrose.jpeg', // Placeholder file path
    price: "$3,598,000",
    position: { lat: 43.812781389239866, lng: -79.38959854963464 },
  },
  {
    address: '83 Fairway Drive N',
    numBeds: 6,
    numBaths: 5,
    sqft: "5000+",
    imageUrl: 'src/assets/images/smart-search/83_fairway.jpeg', // Placeholder file path
    price: "$4,780,000",
    position: { lat: 43.81377299229581, lng: -79.38314279101925 },
  },
  
  {
    address: '17 English Lane',
    numBeds: 8,
    numBaths: 5,
    sqft: "3000-3500",
    imageUrl: 'src/assets/images/smart-search/17_old_english.jpeg', // Placeholder file path
    price: "$4,790,000",
    position: { lat: 43.80700778331176, lng: -79.39351917567795 },
  },
  {
    address: '15 Laureleaf Road',
    numBeds: 4,
    numBaths: 3,
    sqft: "3000-3500",
    imageUrl: 'src/assets/images/smart-search/15_laureleaf.jpeg', // Placeholder file path
    price: "$3,388,000",
    position: { lat: 43.808379048375315, lng: -79.38626694684244 },
  },
];

const SmartSearch = (comingSoon = true) => {
  const [tabValue, setTabValue] = useState(0);
  const [messages, setMessages] = useState([]);
  const [inputValue, setInputValue] = useState('');
  const [currentPropertyIndex, setCurrentPropertyIndex] = useState(0);
  const [markers, setMarkers] = useState([]);
  const [typingMessage, setTypingMessage] = useState([]);
  const [typingIndex, setTypingIndex] = useState(0);
  const [results, setResults] = useState([]);
  const classes = useStyles();

  const [logoVisible, setLogoVisible] = useState(true);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const handleInputChange = (event) => {
    setInputValue(event.target.value);
  };

  const handleSendMessage = () => {
    if (inputValue.trim()) {
      setLogoVisible(false); // Hide the logo
      const newMessages = [...messages, { text: inputValue, fromUser: true }];
      setMessages(newMessages);
      setInputValue('');
      setTimeout(() => {
        const newMessage = "Here are some 4-bedroom homes that meet your criteria. ";
        const newMessage2 = "I've marked these homes on the map for you to review. Click on each marker to see more details about the property, including photos, price, and a brief description.";
        const newMessageList = [
          ...newMessages,
          { text: '', fromUser: false },
          {
            text: '',
            fromUser: false,
            type: 'property',
            properties: mockProperties,
          },
        ];
        setMessages(newMessageList);
        setTypingMessage([newMessage, newMessage2].join(' ').split(' '));
        setTypingIndex(0);
        setMarkers([...mockProperties.map(property => property.position)]);
        setCurrentPropertyIndex(0); // Reset property index
      }, 1000);
    }
  };  

  useEffect(() => {
    if (typingIndex < typingMessage.length) {
      const timeoutId = setTimeout(() => {
        setMessages((prevMessages) => {
          const updatedMessages = [...prevMessages];
          updatedMessages[updatedMessages.length - 2].text = typingMessage.slice(0, typingIndex + 1).join(' ');
          return updatedMessages;
        });
        setTypingIndex((prevIndex) => prevIndex + 1);
      }, 50); // Adjust the delay to control the typing speed
      return () => clearTimeout(timeoutId);
    } else if (typingIndex === typingMessage.length && typingMessage.length > 0) {
      setResults(mockProperties); // Set results once typing is complete
    }
  }, [typingIndex, typingMessage]);

  const handleNextProperty = () => {
    setCurrentPropertyIndex((prevIndex) => (prevIndex + 1) % messages[messages.length - 1].properties.length);
  };

  const handlePrevProperty = () => {
    setCurrentPropertyIndex((prevIndex) => (prevIndex - 1 + messages[messages.length - 1].properties.length) % messages[messages.length - 1].properties.length);
  };

  const [values, setValues] = useState({
    Lsc: [],
    minStatusDateRange: '',
    maxStatusDateRange: '',
    Type_own1_out: [],
    sqft: [],
    A_c: [],
    Yr_built: [],
    Bsmt1_out: [],
    Br: [], // Set default value for Bedrooms to 4
    Bath_tot: [],
    minPrice: '',
    maxPrice: '',
    Num_kit: [],
    Gar_spaces: [],
    Park_spcs: [],
    Tot_park_spcs: [],
  });  
  
  const handleChange = (field) => (event) => {
    const value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
    setValues((prevValues) => ({
      ...prevValues,
      [field]: value,
    }));
  };
  
  

  const resetFilters = () => {
    setValues({
      Lsc: [],
      minStatusDateRange: '',
      maxStatusDateRange: '',
      Type_own1_out: [],
      sqft: [],
      A_c: [],
      Yr_built: [],
      Bsmt1_out: [],
      Br: [], // Set default value for Bedrooms to 4
      Bath_tot: [],
      minPrice: '',
      maxPrice: '',
      Num_kit: [],
      Gar_spaces: [],
      Park_spcs: [],
      Tot_park_spcs: [],
    });
  };  


  const [selectedMarker, setSelectedMarker] = useState(null);

  const [selectedHomes, setSelectedHomes] = useState([]);

  const handleCheckboxChange = (property) => {
    setSelectedHomes((prevSelectedHomes) => {
      if (prevSelectedHomes.includes(property)) {
        return prevSelectedHomes.filter((home) => home !== property);
      } else {
        return [...prevSelectedHomes, property];
      }
    });
  };
  
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };



  return (
    <Container>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Breadcrumb />
        </Grid>
        <Grid item xs={12}>
          <Typography variant="h4">Smart Search</Typography>
        </Grid>
        {comingSoon && <ComingSoon />}
        {!comingSoon && <>
          <Grid item xs={6}>
            <Paper style={{ height: 'calc(100vh - 200px)', display: 'flex', flexDirection: 'column' }}>
              {logoVisible && (
                <Box className={classes.logoContainer}>
                  <img src={logo} alt="Smart Search Logo" style={{ width: '250px', marginBottom: '16px' }} />
                </Box>
              )}
              {!logoVisible && (
                <Box className={classes.chatList}>
                  <List>
                    {messages.map((message, index) => (
                      <ListItem key={index} style={{ justifyContent: message.fromUser ? 'flex-end' : 'flex-start' }}>
                        {message.type === 'property' ? (
                          <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                            <IconButton onClick={handlePrevProperty} disabled={message.properties.length <= 1}>
                              <ArrowBackIcon />
                            </IconButton>
                            <div style={{ display: 'flex', overflow: 'hidden', width: '100%' }}>
                              {[0, 1, 2].map((offset) => {
                                const propertyIndex = (currentPropertyIndex + offset) % message.properties.length;
                                const property = message.properties[propertyIndex];
                                return (
                                  <Card
                                    key={propertyIndex}
                                    className={`${classes.card} ${offset < 2 ? classes.active : classes.faded}`}
                                  >
                                    <CardMedia
                                      className={classes.media}
                                      image={property.imageUrl}
                                      title={property.address}
                                    />
                                    <CardContent className={classes.cardContent}>
                                      <Typography variant="h6" component="div"> {/* Reduced font size */}
                                        {property.address}
                                      </Typography>
                                      <Typography variant="body2" color="textSecondary" component="p">
                                        {property.numBeds} beds
                                      </Typography>
                                      <Typography variant="body2" color="textSecondary" component="p">
                                        {property.numBaths} baths
                                      </Typography>
                                      <Typography variant="body2" color="textSecondary" component="p">
                                        {property.sqft} sqft
                                      </Typography>
                                      <Typography variant="body2" color="textSecondary" component="p">
                                        {property.price}
                                      </Typography>
                                    </CardContent>
                                  </Card>
                                );
                              })}
                            </div>
                            <IconButton onClick={handleNextProperty} disabled={message.properties.length <= 1}>
                              <ArrowForwardIcon />
                            </IconButton>
                          </div>
                        ) : (
                          <Paper className={message.fromUser ? classes.userMessage : classes.computerMessage}>
                            {message.text}
                          </Paper>
                        )}
                      </ListItem>
                    ))}
                  </List>
                </Box>
              )}
              <Box style={{ display: 'flex', padding: '16px', borderTop: '1px solid #ccc' }}>
                <TextField
                  fullWidth
                  variant="outlined"
                  value={inputValue}
                  onChange={handleInputChange}
                  placeholder="Search for homes"
                />
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleSendMessage}
                  style={{ backgroundColor: '#3f51b5', minWidth: '56px', padding: '0' }}
                >
                  <SendIcon />
                </Button>
              </Box>
            </Paper>
          </Grid>
          <Grid item xs={6}>
            <Grid container style={{ height: '100%' }}>
              <Grid item xs={12} style={{ height: '50%' }}>
                <Paper style={{ height: '100%' }}>
                  <LoadScript googleMapsApiKey="AIzaSyDXcuNu9hM04ec2v4lqzrfcrmIKjILZMRU">
                  <GoogleMap
                    mapContainerStyle={containerStyle}
                    center={center}
                    zoom={15}
                  >
                    {markers.map((marker, index) => (
                      <Marker
                        key={index}
                        position={marker}
                        icon={{
                          url: selectedHomes.includes(mockProperties[index])
                            ? 'http://maps.google.com/mapfiles/ms/icons/green-dot.png'
                            : 'http://maps.google.com/mapfiles/ms/icons/red-dot.png',
                        }}
                        onClick={() => setSelectedMarker(mockProperties[index])} // Set selected marker on click
                      />
                    ))}


                    {selectedMarker && (
                      <InfoWindow
                        position={selectedMarker.position}
                        onCloseClick={() => setSelectedMarker(null)}
                      >
                        <div>
                          <img
                            src={selectedMarker.imageUrl}
                            alt={selectedMarker.address}
                            style={{ width: '100px', height: 'auto', marginBottom: '8px' }}
                          />
                          <Typography variant="body1">{selectedMarker.address}</Typography>
                          <Typography variant="body2">{selectedMarker.numBeds} beds</Typography>
                          <Typography variant="body2">{selectedMarker.numBaths} baths</Typography>
                          <Typography variant="body2">{selectedMarker.price}</Typography>
                        </div>
                      </InfoWindow>
                    )}
                  </GoogleMap>

                  </LoadScript>
                </Paper>
              </Grid>
              <Grid item xs={12} style={{ height: '50%' }}>
                <Paper style={{ height: '100%', overflow: 'hidden' }}>
                  <Tabs
                    value={tabValue}
                    onChange={handleTabChange}
                    indicatorColor="primary"
                    textColor="primary"
                    centered
                  >
                    <Tab label="Filters" />
                    <Tab label="Results" />
                  </Tabs>
                  <Box sx={{ height: 'calc(100% - 48px)', overflowY: 'auto' }}>
                    <Grid container spacing={3} style={{ padding: 16 }}>
                      <Grid item xs={12}>
                        {tabValue === 0 && (
                          <SearchFilters
                            values={values}
                            handleChange={handleChange}
                            resetFilters={resetFilters}
                          />
                        )}
                        {tabValue === 1 && (
                          <>
                            <Table>
                              <TableHead>
                                <TableRow>
                                  <TableCell>Image</TableCell> {/* Header for the image */}
                                  <TableCell>Address</TableCell>
                                  <TableCell>Bedrooms</TableCell>
                                  {/* <TableCell>Bathrooms</TableCell> Remove this line */}
                                  <TableCell>Square Footage</TableCell>
                                  <TableCell>Price</TableCell> {/* Header for the price */}
                                  <TableCell>Select</TableCell> {/* Header for the checkbox */}
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {results.map((property, index) => (
                                  <TableRow key={index}>
                                    <TableCell>
                                      <img src={property.imageUrl} alt={property.address} width="50" /> {/* Add the image */}
                                    </TableCell>
                                    <TableCell>{property.address}</TableCell>
                                    <TableCell>{property.numBeds}</TableCell>
                                    {/* <TableCell>{property.numBaths}</TableCell> Remove this line */}
                                    <TableCell>{property.sqft}</TableCell>
                                    <TableCell>{property.price}</TableCell> {/* Add the price */}
                                    <TableCell>
                                      <Checkbox
                                        checked={selectedHomes.includes(property)}
                                        onChange={() => handleCheckboxChange(property)}
                                      />
                                    </TableCell>

                                  </TableRow>
                                ))}
                              </TableBody>
                            </Table>
                            <Box sx={{ padding: "16px", borderTop: "1px solid #ccc", position: "sticky", bottom: 0, backgroundColor: "#fff", zIndex: 1 }}>
                              <Button
                                variant="contained"
                                color="primary"
                                sx={{ marginRight: "16px" }} // Increase the margin-right to 16px for spacing
                                style={{ backgroundColor: '#3f51b5', height: "56px", marginRight: "16px" }}
                                onClick={resetFilters}
                              >
                                Reset
                              </Button>
                              <Button
                                variant="contained"
                                color="primary"
                                style={{ backgroundColor: '#3f51b5', height: "56px" }}
                                aria-controls="export-menu" // Add this line
                                aria-haspopup="true" // Add this line
                                onClick={handleClick} // Update onClick handler
                              >
                                Export
                              </Button>
                              <Menu
                                id="export-menu"
                                anchorEl={anchorEl}
                                keepMounted
                                open={Boolean(anchorEl)}
                                onClose={handleClose}
                                anchorOrigin={{
                                  vertical: 'top',
                                  horizontal: 'left',
                                }}
                                transformOrigin={{
                                  vertical: 'bottom',
                                  horizontal: 'left',
                                }}
                              >
                                <MenuItem onClick={handleClose}>
                                  <ListItemIcon>
                                    <img src={SmartCmaIcon} />
                                  </ListItemIcon>
                                  <ListItemText primary="Smart CMA" />
                                </MenuItem>
                                <MenuItem onClick={handleClose}>
                                  <ListItemIcon>
                                    <img src={SmartCmaIcon} />
                                  </ListItemIcon>
                                  <ListItemText primary="Smart Reports" />
                                </MenuItem>
                              </Menu>
                            </Box>
                          </>
                        )}
                      </Grid>
                    </Grid>
                  </Box>
                </Paper>
              </Grid>
            </Grid>
          </Grid>
        </>}
      </Grid>
    </Container>
  );
};

export default SmartSearch;
